<template>
  <div
    id="dashboard-dynamic"
    class="dashboard--dynamic width-responsiveness"
  >
    <div
      v-if="!toggle.covax"
      class="card-container"
    >
      <CarouselBanner />

      <h3 class="dashboard__lab_name">
        {{ `${profile.laboratoryName}` }}
      </h3>
      <h3 class="dashboard__hello">
        {{ `${title}` }}
      </h3>
      <h3
        v-if="getAlertsNumber > 0"
        class="dashboard__hello"
      >
        <span
          class="dashboard__notifications-count"
          @click="openNotificationsSidebar"
        >
          {{ `Você tem ${getAlertsNumber ? getAlertsNumber : 0} notificações não lidas` }}
        </span>
      </h3>
      <div class="row totem-only">
        <div class="col">
          <card-search style="margin-bottom: 0" />
        </div>
      </div>
      <div class="row">
        <div class="card-row card-row--notifications">
          <card-pendencies />
          <card-recollects />
        </div>
        <div class="card-row card-row--notifications">
          <card-reschedule />
          <card-panic-alert />
          <card-documents />
        </div>
        <div class="totem-only totem-only--grid">
          <card-traceability />
          <card-tracking />
        </div>
        <card-quick-links />
      </div>
      <div class="row">
        <div class="col">
          <card-search class="desktop-only" />
          <card-daily-routine />
        </div>
        <card-traceability class="desktop-only" />
        <card-tracking class="desktop-only" />
      </div>
    </div>

    <div
      v-else
      class="card-container"
    >
      <CarouselBanner />
      <div class="row">
        <div class="card-row">
          <card-search />
        </div>
        <div class="card-row">
          <card-recollects />
          <card-reschedule />
        </div>
        <card-quick-links />
      </div>
      <div class="row">
        <card-traceability />
        <card-tracking />
      </div>
    </div>

    <order-maintenance-search />

    <feedback-banner
      text="O que você está achando do novo sistema AOL 2.0?"
      feedback-step="full-system"
    />

    <NotificationHomeModal ref="notificationHomeModal" />
  </div>
</template>

<script>
import CardPendencies from './Cards/CardPendencies'
import CardWelcome from './Cards/CardWelcome'
import CardRecollects from './Cards/CardRecollects'
import CardReschedule from './Cards/CardReschedule'
import CardPanicAlert from './Cards/CardPanicAlert'
import CardDocuments from './Cards/CardDocuments'
import CardQuickLinks from './Cards/CardQuickLinks'
import CardSearch from './Cards/CardSearch'
import CardDailyRoutine from './Cards/CardDailyRoutine'
import CardTraceability from './Cards/CardTraceability'
import CardTracking from './Cards/CardTracking'
import FeedbackBanner from '@/components/common/feedback/FeedbackBanner'
import OrderMaintenanceSearch from '@/components/common/OrderMaintenanceSearch'
import Moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import {
  PENDENCIES_PERIOD_DAYS_DEFAULT,
  PENDENCIES_STATUS_PENDING,
  DASHBOARD_INTERVAL_TIME_STAMP_MILISECONDS,
  DASHBOARD_INTERVAL_UPDATE_MILISECONDS,
  RESULTS_RECENTS_DAYS_RANGE,
} from '@/enums'
import NotificationHomeModal from '@/components/Dashboard/NotificationHomeModal.vue'
import { RECOLLECT_PERIOD_DAYS_DEFAULT } from '../../enums'
import CarouselBanner from './CarouselBanner.vue'
import SearchBanner from './SearchBanner.vue'

export default {
  name: 'Dynamic',
  components: {
    'feedback-banner': FeedbackBanner,
    'order-maintenance-search': OrderMaintenanceSearch,
    'card-pendencies': CardPendencies,
    'card-welcome': CardWelcome,
    'card-recollects': CardRecollects,
    'card-reschedule': CardReschedule,
    'card-quick-links': CardQuickLinks,
    'card-search': CardSearch,
    'card-daily-routine': CardDailyRoutine,
    'card-traceability': CardTraceability,
    'card-tracking': CardTracking,
    CardPanicAlert,
    CardDocuments,
    NotificationHomeModal,
    CarouselBanner,
    SearchBanner,
  },
  data() {
    return {
      updateTime: new Date(),
      daysRangeToGetResults: RESULTS_RECENTS_DAYS_RANGE,
      intervalForUpdateTimeLabel: null,
      intervalForCallAPIs: null,
    }
  },
  computed: {
    ...mapGetters([
      'getUpdateTime',
      'getTodayDate',
      'isComunicationSidebarVisible',
      'getAlertsNumber',
      'getMessagesNumber',
      'profile',
      'toggle',
    ]),
    today: function () {
      return new Date()
    },
    title: function () {
      let day = new Date()
      let hour = day.getHours()
      if (hour >= 6 && hour < 12) {
        return `Olá ${this.profile?.name || ''}, bom dia!`
      } else if (hour >= 12 && hour < 18) {
        return `Olá ${this.profile?.name || ''}, boa tarde!`
      }
      return `Olá ${this.profile?.name || ''}, boa noite!`
    },
  },
  watch: {
    $route(to, from) {
      this.openRouterPage()
    },
    getAlertsNumber: function (newVal) {
      this.showNotification()
    },
    getMessagesNumber: function (newVal) {
      this.showNotification()
    },
  },
  created() {
    this.setTimeOut()
    this.updateToday()
    this.$analytics.pushAnalyticsEvent('vpageview', {
      page: 'dashboard/new',
      'id-usuario': this.profile.id,
      'id-lab': this.profile.id_laboratory,
      nlab: this.profile.laboratoryName,
    })
  },
  mounted() {
    if (this.profile.lastAccessDate === null) {
      this.$router.push({ path: '/perfil-de-acesso' })
    }
    this.requestAllAPIs()
    this.showNotification()
  },
  beforeDestroy() {
    this.setComunicationSidebarShowOff(false)
    this.changeTabShowOff(false)
    this.clearData()
    this.destroyIntervals()
  },
  methods: {
    ...mapActions([
      'updateUpdateTime',
      'updateToday',
      'setComunicationSidebarShowOff',
      'changeTabShowOff',
      'updateResultsStatistics',
      'resetResultsStatistics',
      'getTotalDestinations',
      'getTotalTraceabilityStatus',
      'getTraceabilityGetGroupedExamsCount',
      'getTotalDestinations',
      'clearAllTraceabilityData',
      'getAlertsForLaboratory',
      'getMessagesForLaboratory',
      'clearAllMessageData',
      'clearAlertDataForLaboratory',
      'getTotalPendenciesQuantity',
      'selectPendenciesFilter',
      'getTotalRecollectsByStatus',
      'setCurrentTabRecollect',
      'getReschedulesTotalNumber',
      'getPanicAlertsTotalNumber',
      'getPendingDocumentsTotalNumber',
      'updateUpdateTimeText',
      'selectRecollectParams',
      'recollectParans',
    ]),
    updateDashboard() {
      this.updateTime = new Date()
      this.clearData()
      this.requestAllAPIs()
    },
    requestAllAPIs() {
      this.clearAllTraceabilityData()
      this.resetResultsStatistics()
      this.updateResultsStatistics(this.daysRangeToGetResults)
      if (this.toggle.traceability) {
        this.getTotalTraceabilityStatus()
        this.getTotalDestinations()
      }
      this.getAlertsForLaboratory()
      this.getMessagesForLaboratory()
      this.getTotalDestinations()
      this.getTraceabilityGetGroupedExamsCount()
      this.getAlertsForLaboratory()
      this.getMessagesForLaboratory()
      this.getReschedulesTotalNumber()
      this.selectPendenciesFilter({
        startDate: Moment(new Date())
          .subtract(PENDENCIES_PERIOD_DAYS_DEFAULT, 'days')
          .format('DD/MM/YYYY'),
        endDate: Moment(new Date()).format('DD/MM/YYYY'),
        status: [PENDENCIES_STATUS_PENDING],
      })
      if (this.toggle.recollect) {
        this.selectRecollectParams({
          ...this.recollectParans,
          startDate: Moment(this.today)
            .subtract(RECOLLECT_PERIOD_DAYS_DEFAULT, 'days')
            .toDate(),
          endDate: Moment(this.today).toDate(),
          limit: 20,
          offset: 0,
          status: 'PENDENTE',
        })
        this.setCurrentTabRecollect(1)
        this.getTotalRecollectsByStatus('NAO_REALIZADO')
      }
      this.getReschedulesTotalNumber()
      this.getPanicAlertsTotalNumber()
      this.getPendingDocumentsTotalNumber()
      if (this.toggle.pendenciesManagement) {
        this.getTotalPendenciesQuantity()
      }
      this.updateUpdateTime()
      this.updateUpdateTimeText()
    },
    clearData() {
      this.clearAllMessageData()
      this.clearAlertDataForLaboratory()
    },
    showNotification() {
      if (this.toggle.notification_view) {
        setTimeout(() => {
          this.openNotificationHomeModal()
        }, 300)

        if (this.getMessagesNumber > 0) {
          this.setComunicationSidebarShowOff(true)
          this.changeTabShowOff(true)
        } else if (this.getAlertsNumber > 0) {
          this.setComunicationSidebarShowOff(true)
          this.changeTabShowOff(false)
        } else {
          this.setComunicationSidebarShowOff(false)
        }
      }
    },
    openRouterPage(val) {
      this.setComunicationSidebarShowOff(false)
      this.$router.push({ path: val })
    },
    setTimeOut() {
      this.intervalForUpdateTimeLabel = setInterval(() => {
        this.updateUpdateTimeText()
      }, DASHBOARD_INTERVAL_TIME_STAMP_MILISECONDS)
      this.intervalForCallAPIs = setInterval(() => {
        console.info('atualizando dashboard')
        this.updateDashboard()
      }, DASHBOARD_INTERVAL_UPDATE_MILISECONDS)
    },
    destroyIntervals() {
      clearInterval(this.intervalForUpdateTimeLabel)
      clearInterval(this.intervalForCallAPIs)
    },
    openNotificationHomeModal() {
      this.$refs.notificationHomeModal.openNotificationHomeModal()
    },
    openNotificationsSidebar() {
      this.$root.$emit('manualSidebarOpen')

      setTimeout(() => {
        this.setComunicationSidebarShowOff(true)
        this.changeTabShowOff(false)
      }, 50)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../static/stylesheets/variables';

.dashboard {
  &--dynamic {
    height: 100vh;
    padding-top: 68px !important;
    display: flex;
    flex-direction: column;

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      align-items: center;
    }

    .card-container {
      margin: auto;
      width: 85%;
      padding-bottom: 2em;

      @media only screen and (max-width: 1154px) {
        width: 100%;
      }

      @media only screen and (max-width: 1069px) {
        margin-top: 3em;
      }

      @media screen and (-ms-high-contrast: active),
        screen and (-ms-high-contrast: none) {
        display: block;
        height: 95%;
      }

      .row {
        display: grid;
        // grid-template-columns: 1fr 1fr 1fr; -- ROW ANTIGA
        grid-template-columns: 2fr 3fr 2fr;
        grid-column-gap: 20px;

        @media (max-width: 1080px) {
          grid-template-columns: 1fr;
          grid-row-gap: 20px;
        }

        @media (max-width: 1069px) {
          grid-template-columns: 1fr;
        }

        @media screen and (-ms-high-contrast: active),
          screen and (-ms-high-contrast: none) {
          display: flex;
          flex: 1;

          @media only screen and (max-width: 1081px) {
            display: block;
          }
        }

        .col > *:first-child {
          margin-bottom: 20px;
        }

        &:last-child {
          margin-bottom: 0px;
        }

        .card-row {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          grid-column-gap: 20px;
          grid-row-gap: 20px;

          @media (max-width: 768px) {
            grid-template-columns: 1fr;
          }

          &--notifications {
            @media only screen and (min-width: 1081px) {
              margin-bottom: 20px;
              grid-template-columns: repeat(auto-fit, minmax(10em, 1fr));
            }

            .md-card {
              height: 130px;
              padding-bottom: 20px;

              @media screen and (-ms-high-contrast: active),
                screen and (-ms-high-contrast: none) {
                margin: 0 10px;

                &:first-of-type {
                  margin-left: 0;
                }
              }
            }
          }

          @media screen and (-ms-high-contrast: active),
            screen and (-ms-high-contrast: none) {
            display: flex;
            flex: 1;
            flex-wrap: nowrap;
            flex-direction: row;

            @media (max-width: 1069px) {
              display: flex;
              flex-wrap: wrap;
              margin: 0 -10px 20px;
            }
          }
        }

        @media screen and (-ms-high-contrast: active),
          screen and (-ms-high-contrast: none) {
          .dynamic-card {
            margin-right: 1em;
          }
        }
      }

      .card-disabled {
        background-color: rgba(255, 255, 255, 0.4);
        cursor: not-allowed;

        .md-card-header,
        .md-card-content > div:first-child {
          opacity: 0.4;
          pointer-events: none;
        }
      }
    }
  }

  &__hello {
    font-weight: 700;
    font-size: 24px;
    color: #ec2072;
    margin-bottom: 24px;
  }

  &__notifications-count {
    cursor: pointer;
    transition: opacity 0.2s ease;
    display: inline;

    &:hover {
      opacity: 0.8;
    }
  }

  &__lab_name {
    font-weight: 700;
    font-size: 16px;
    color: #808080;
    margin-bottom: 16px;
  }
}

.snackbar-warning {
  &.md-snackbar {
    .md-snackbar-container {
      width: auto;
      font-family: 'Exo 2', sans-serif !important;
      font-style: normal;
      font-weight: 500px;
      font-size: 14px;
      line-height: 26px;
      text-align: center;
      background-color: #7f1a54;
      color: white;
      margin: 0;
      max-width: max-content;
      padding: 11px 24px;
      min-height: min-content;

      .action {
        font-weight: bold;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}

.totem-only {
  display: none !important;
}

.desktop-only {
  display: block;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .col {
    flex: 1;
  }
}

@media (max-width: 1080px) {
  .desktop-only {
    display: none !important;
  }

  .totem-only {
    display: flex !important;
    margin-bottom: 20px;

    &.row {
      display: grid !important;
      grid-template-columns: 1fr;
      grid-gap: 20px;
    }

    &--grid {
      display: grid !important;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
      margin-bottom: -30px;

      > div {
        flex: 1;
      }
    }

    .card-traceability {
      margin-top: 0;
    }

    #traceability {
      padding: 0 !important;
    }
  }
}

@media (max-width: 768px) {
  .totem-only {
    &--grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>
